import { Check } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

const TINT_STYLES = {
  need: {
    chip: 'border-sage-600 bg-sage-50 text-foreground dark:border-sage-500 dark:bg-sage-950/40',
    icon: 'bg-sage-100 text-sage-700 dark:bg-sage-900/60 dark:text-sage-300',
    tick: 'border-sage-600 bg-sage-600',
  },
  want: {
    chip: 'border-group-wants bg-[#F5EEE0] text-foreground dark:border-amber-700/60 dark:bg-amber-950/35',
    icon: 'bg-[#F5EEE0] text-[#8A6D3B] dark:bg-amber-950/50 dark:text-amber-300',
    tick: 'border-[#8A6D3B] bg-[#8A6D3B] dark:border-amber-600 dark:bg-amber-600',
  },
  save: {
    chip: 'border-group-savings bg-[#E8EEF2] text-foreground dark:border-slate-600/60 dark:bg-slate-900/40',
    icon: 'bg-[#E8EEF2] text-[#4F6879] dark:bg-slate-900/60 dark:text-slate-300',
    tick: 'border-[#4F6879] bg-[#4F6879] dark:border-slate-500 dark:bg-slate-500',
  },
};

export function SelectionChip({ label, icon: Icon, tint = 'need', selected, onToggle }) {
  const styles = TINT_STYLES[tint] || TINT_STYLES.need;

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={selected}
      className={cn(
        'type-chip flex w-full min-w-0 items-center gap-space-2 rounded-ds-md border-[1.5px] border-border bg-card px-space-2-5 py-space-2 text-left font-semibold text-muted-foreground transition',
        'hover:border-muted-foreground/30',
        selected && styles.chip,
      )}
    >
      <span
        className={cn(
          'flex h-7 w-7 shrink-0 items-center justify-center rounded-ds-sm',
          selected ? styles.icon : 'bg-muted text-muted-foreground',
        )}
      >
        <Icon className="h-4 w-4" aria-hidden />
      </span>
      <span className="min-w-0 flex-1 break-words leading-tight">{label}</span>
      <span
        className={cn(
          'flex h-4 w-4 shrink-0 items-center justify-center rounded-ds-full border-2 border-border text-white',
          selected && styles.tick,
        )}
        aria-hidden
      >
        <Check className={cn('h-2.5 w-2.5', selected ? 'opacity-100' : 'opacity-0')} aria-hidden />
      </span>
    </button>
  );
}
